import { useCallback, useState, useEffect } from "react";
import { getSessionStorage, setSessionStorage } from "@utils";
import { useLocation } from "react-router";
import { replace } from "connected-react-router";
import { useSelector, useDispatch } from "react-redux";
import { selectLoading } from "@store/UIState/selectors";

const HISTORY_STORAGE_KEY = "HISTORY";

const useHeaderNavigationItem = (
  title: string,
  currentTab: string,
  path: string
) => {
  const [isActive, setIsActive] = useState(false);
  const isLoading = useSelector(selectLoading);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const savePathHandler = useCallback(() => {
    if (isLoading) return;

    if (pathname !== "/system-error") {
      const data = { [currentTab]: pathname };
      setSessionStorage(HISTORY_STORAGE_KEY, data);
    }

    const storagePath = getSessionStorage(HISTORY_STORAGE_KEY)[title];
    storagePath ? dispatch(replace(storagePath)) : dispatch(replace(path));
  }, [currentTab, pathname, dispatch, path, title, isLoading]);

  useEffect(() => {
    pathname.includes(path) ? setIsActive(true) : setIsActive(false);
  }, [pathname, path]);

  return { savePathHandler, isActive };
};

export default useHeaderNavigationItem;
